import { toast } from "react-toastify";

// ======================================================
// GET CURRENT DATE
// ======================================================

export function getCurrentDate() {
  const today = new Date();

  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();

  return `${day} /${month}/${year} `;
}

// ======================================================
// CLOUDINARY CONFIGURATION
// ======================================================

const CLOUDINARY_CLOUD_NAME = "dctryhj1b";

// This must be the name of an UNSIGNED upload preset
// created in your Cloudinary account.
const CLOUDINARY_UPLOAD_PRESET = "lts_preset";

// ======================================================
// UPLOAD IMAGE TO CLOUDINARY
// ======================================================

export async function handleImageSubmit(
  imageFile,
  setImageFile,
  setImageDownloadURL,
  folderName = "Home/lts"
) {
  if (!imageFile) {
    toast.warning("Image Not Selected");
    return;
  }

  try {
    const formData = new FormData();

    // Image file
    formData.append("file", imageFile);

    // Cloudinary unsigned upload preset
    formData.append(
      "upload_preset",
      CLOUDINARY_UPLOAD_PRESET
    );

    // Cloudinary folder
    formData.append("folder", folderName);

    // Cloudinary upload endpoint
    const uploadURL =
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;

    const response = await fetch(uploadURL, {
      method: "POST",
      body: formData,
    });

    // Get Cloudinary response
    const data = await response.json();

    // Check for Cloudinary error
    if (!response.ok) {
      console.error("Cloudinary Response:", data);

      throw new Error(
        data?.error?.message ||
        "Cloudinary upload failed"
      );
    }

    console.log("Cloudinary Upload Successful:", data);

    // Check secure URL
    if (!data.secure_url) {
      throw new Error(
        "Cloudinary did not return an image URL"
      );
    }

    // Save Cloudinary URL to state
    setImageDownloadURL(data.secure_url);

    // Clear selected image
    setImageFile(null);

    toast.success("Image Uploaded Successfully");

    // Return URL as well
    return data.secure_url;

  } catch (error) {

    console.error(
      "Cloudinary Upload Error:",
      error
    );

    toast.error(
      error.message ||
      "Something Went Wrong While Uploading Image"
    );

    throw error;
  }
}

// ======================================================
// IMAGE FILE CHANGE
// ======================================================

export function handleImageChange(
  event,
  setImageFile
) {
  const selectedImage =
    event.target.files[0];

  if (selectedImage) {
    setImageFile(selectedImage);
  }
}

// ======================================================
// COPY IMAGE URL
// ======================================================

export function handleURLCopy(
  imageDownloadURL,
  setCopyURL
) {
  if (!imageDownloadURL) {

    toast.info("Could not find Image URL");

    return;
  }

  const tempInput =
    document.createElement("input");

  tempInput.value = imageDownloadURL;

  document.body.appendChild(tempInput);

  tempInput.select();

  document.execCommand("copy");

  document.body.removeChild(tempInput);

  toast.success(
    "Image URL copied to clipboard!"
  );

  setCopyURL(true);

  setTimeout(() => {
    setCopyURL(false);
  }, 3000);
}

// ======================================================
// LOGOUT
// ======================================================

export async function handleLogOut(logOut) {
  try {

    await logOut();

    toast.success(
      "Signed Out Successfully"
    );

  } catch (error) {

    console.error(
      "Logout Error:",
      error
    );

    toast.error(
      "Error Signing Out"
    );
  }
}

// ======================================================
// GOOGLE SIGN IN
// ======================================================

export async function handleSignIn(
  googleSignIn
) {
  try {

    await googleSignIn();

    toast.success(
      "Signed In Successfully"
    );

  } catch (error) {

    console.error(
      "Sign In Error:",
      error
    );

    if (
      error.message ===
      "no_internet_connection"
    ) {

      toast.error(
        "No Internet Connection."
      );

    } else {

      toast.error(
        "Error Signing In."
      );
    }
  }
}

// ======================================================
// EXTRACT USERNAME
// ======================================================

export function extractUsername(email) {

  const regexWithNumber =
    /^(.*?)(\d+)(?=@)/;

  const regexWithoutNumber =
    /^(.*?)@/;

  let username = "";

  if (regexWithNumber.test(email)) {

    const matches =
      email.match(regexWithNumber);

    if (
      matches &&
      matches.length >= 2
    ) {
      username = matches[1];
    }

  } else if (
    regexWithoutNumber.test(email)
  ) {

    const matches =
      email.match(regexWithoutNumber);

    if (
      matches &&
      matches.length >= 2
    ) {
      username = matches[1];
    }
  }

  return username;
}

// ======================================================
// CALCULATE LOCAL STORAGE SIZE
// ======================================================

export function calculateLocalStorageSize() {

  let totalBytes = 0;

  for (let key in localStorage) {

    if (
      localStorage.hasOwnProperty(key)
    ) {

      totalBytes +=
        (localStorage[key].length +
          key.length) * 2;
    }
  }

  return totalBytes;
}
